import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from "@angular/core";
import { Router } from "@angular/router";
import { UI } from "../../../../services/ui.service";
import { LiveFeed } from "../../../../domain/live-feed";
import { UploadService } from "../../../../infrastructure/upload/upload-service";
import { LiveFeedRepository } from "../../../../domain/live-feed-repository";
import { Socket } from "app/js/src/infrastructure/socket.service";
import { v4 as uuid } from "uuid";
import { LiveFeedPreview } from "app/js/src/domain/live-feed-preview";
import { User } from "../../../../domain/user";

@Component({
  selector: "live-feed-library-item",
  templateUrl: "./liveFeedLibraryItem.html",
  styleUrls: ["./liveFeedLibraryItem.scss"],
})
export class LiveFeedLibraryItemComponent {
  @Input()
  item: LiveFeed;

  @Input()
  currentUser: User;

  @Input()
  viewMode = "gallery";

  menuOpen = false;
  dragged = false;

  @Output()
  deleteLiveFeedEmitter = new EventEmitter();

  constructor(
    private ref: ElementRef,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private socketService: Socket,
    private ui: UI,
    private uploadService: UploadService,
    private liveFeedRepository: LiveFeedRepository,
  ) {}

  ngOnInit() {
    this.ref.nativeElement.addEventListener(
      "dragstart",
      this.onDragStart.bind(this),
      false,
    );
    this.ref.nativeElement.addEventListener(
      "dragend",
      this.onDragEnd.bind(this),
      false,
    );
  }

  deleteLiveFeed() {
    this.ui.notify(this.ui.EVENTS.ShowConfirm, {
      title: "Delete live feed",
      message: "Are you sure about that?",
      buttons: [
        {
          title: "Yes",
          callback: this.onDeleteConfirmed.bind(this),
        },
        {
          title: "No",
          callback: this.onDeleteCancelled.bind(this),
        },
      ],
    });
  }

  onDeleteConfirmed() {
    this.deleteLiveFeedEmitter.emit();
  }

  onDeleteCancelled() {}

  editLiveFeed() {
    this.router.navigate(["/scheduler/live/edit/", this.item.id]);
  }

  previewLiveFeed() {
    this.socketService
      .createLiveFeedPreview(this.item.id)
      .then((liveFeedPreview: LiveFeedPreview) => {
        const id = uuid();
        const firstAvailabilityZone = Object.keys(
          liveFeedPreview.availabilityZoneUrls,
        )[0];
        const availabilityZoneUrls = new Array<string>(
          liveFeedPreview.availabilityZoneUrls[firstAvailabilityZone].url,
        );
        const data = {
          streamId: liveFeedPreview.id,
          availabilityZoneUrls: availabilityZoneUrls,
          clientId: liveFeedPreview.clientId,
          brodcasterId: liveFeedPreview.brodcasterId,
          name: `${this.item.name} live feed`,
          posterImage: this.item.thumbnail,
        };
        localStorage.setItem(`stream_data_${id}`, JSON.stringify(data));
        window.open(
          `/html/preview.html?id=${id}`,
          `window_${this.item.id}`,
          "width=407,height=300,toolbar=no, menubar=no, resizable=yes",
        );
      });
  }

  onDragStart(event: DragEvent) {
    this.dragged = true;
    event.dataTransfer.setData("text/feed", JSON.stringify(this.item));
    event.dataTransfer.dropEffect = "copy";
  }

  onDragEnd(event) {
    this.dragged = false;
  }

  onUploadThumbnail(event) {
    if (!event.target.files.length) {
      return;
    }
    let url: string;
    this.uploadService
      .uploadSmallFile(event.target.files[0])
      .then((result) => {
        url = result;
        return this.liveFeedRepository.updateThumbnail(this.item.id, url);
      })
      .then(() => {
        this.item.thumbnail = url;
        this.changeDetectorRef.markForCheck();
      });
    event.target.value = "";
  }
}
